import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'
import type { ParsedTemplateVariable } from '@/components/organisms/template-variable-editor/template-variable.interface'
import { TemplateVariableEditor } from '@/components/organisms/template-variable-editor/template-variable-editor.organism'
import { TemplateVariableSyntaxGuide } from '@/components/organisms/template-variable-editor/template-variable-syntax-guide.atom'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'

import type { PromptTemplateDrawerFormSchemaType } from './prompt-template-drawer-form.schema'

interface PromptTemplateContentFieldProps {
  form: UseFormReturn<PromptTemplateDrawerFormSchemaType>
  isDisabled?: boolean
  onVariablesChange?: (variableList: ParsedTemplateVariable[]) => void
}

/**
 * Form field for editing prompt template content with variable highlighting.
 */
export const PromptTemplateContentField = ({
  form,
  isDisabled = false,
  onVariablesChange,
}: PromptTemplateContentFieldProps): ReactNode => (
  <FormField
    control={form.control}
    name="content"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Content</FormLabel>
        <FormControl>
          <TemplateVariableEditor
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            onVariablesChange={onVariablesChange}
            placeholder="Enter template content. Type { to insert a variable..."
            isDisabled={isDisabled}
            minHeight="200px"
            className="prompt-template-content-input"
          />
        </FormControl>
        <TemplateVariableSyntaxGuide className="mt-2" />
        <FormMessage />
      </FormItem>
    )}
  />
)

PromptTemplateContentField.displayName = 'PromptTemplateContentField'
